export const indexAreasPath: string = "/areas";
export const newAreasPath: string = "/areas/new";
export const showAreasPath: string = "/areas/:id";
export const showAreasPathCreator = (id: number|string): string => `/areas/${id}`
export const editAreasPath: string = "/areas/:id/edit"
export const editAreasPathCreator = (id: number|string): string => `/areas/${id}/edit`
